import { createTheme } from "@mui/material/styles";

// Tema era statica (fara palette.mode), asa ca orice cod care se baza pe
// theme.palette.mode==='dark' sau pe bgcolor:'background.paper' ca sa se
// adapteze la dark mode nu facea nimic - era mereu light. Acum getTheme(mode)
// e apelat dinamic din pages/_app.js, in functie de toggle-ul real de tema.
export const getTheme = (mode = "light") =>
	createTheme({
		palette: {
			mode,
			text:
				mode === "dark"
					? {
							primary: "#e4e7eb",
							secondary: "#b8bcc4",
							disabled: "#8a8f98",
							hint: "#8a8f98",
					  }
					: {
							primary: "#5B5B98",
							secondary: "#5B5B98",
							disabled: "#5B5B98",
							hint: "#5B5B98",
					  },
			background:
				mode === "dark"
					? { default: "#0d1015", paper: "#14171c" }
					: { default: "#fff", paper: "#fff" },
			primary: {
				main: "#F0A500",
			},
			secondary: {
				main: "#818093",
			},
			success: {
				main: "#00B69B",
			},
			info: {
				main: "#2DB6F5",
			},
			warning: {
				main: "#FFBC2B",
			},
			danger: {
				main: "#EE368C",
			},
			dark: {
				main: "#260944",
			},
		},

		typography: {
			fontSize: 12,
		},
	});

export default getTheme("light");
